<template>
    <div v-if="value">
        <div class="row" v-for="(tel, it) in lista" :key="it">
            <div class="col col-12 col-md-3">
                <az-input 
                type="select" 
                optionsMode="json" 
                optionsData="id"
                optionsDisplay="search"
                :optionsList="[{id: 'M', search: 'Celular'}, {id: 'F', search: 'Fax'}, {id: 'R', search: 'Fixo'}]"
                icon="fas fa-trash-alt"
                :buttonIcon="true"
                buttonText="fas fa-minus"
                buttonColor="outline-danger"
                @clickButton="excluir(tel)"
                :validate="validate"
                required 
                v-model="tel.telefone.ch_tipo_telefone" />
            </div>
            <div class="col col-12 col-md-3">
                <az-input v-model="tel.telefone.st_numero" required :validate="validate" type="fone" />
            </div>
        </div>

        <button type="button" class="btn btn-outline-secondary btn-sm mt-2" @click="incluir()">
            <i class="fas fa-plus mr-2"></i>
            Incluir Telefone
        </button>
    </div>
</template>

<script>
import AzInput from '../shared/forms/AzInput.vue';
export default {
    data () { 
        return { 

        }
    },

    components: { 
        AzInput,
    },

    props: ['value', 'validate'],
    
    computed: { 
        lista: function () { 
            return this.value.filter (it => { 
                return !it.excluido;
            });
        }
    },

    methods: { 
        incluir () { 
            this.value.push({ 
                excluido: false, 
                telefone: { 
                    ch_tipo_telefone: "",
                    st_numero: "",
                }
            });
        },

        excluir (tel) { 
            tel.excluido = true;
        }
    }
}
</script>